module.exports = __webpack_public_path__ + "img/LUB00001.1f1c57d2.png";